import React from "react";
import { BottomFillIcon, TopFillIcon } from "@t8891/icon";

interface IProps {
  onClick: (e: any) => void;
  action: string;
  data: any;
  show: "region" | "color" | "paymentType" | "insurance" | "";
  setShow: any;
}
const InsuranceList: React.FC<IProps> = ({ show, setShow, action, data, onClick }) => {
  return (
    <div className='w-full relative  flex items-center'>
      <div
        className={`${
          show === "paymentType" || !!action ? "text-primary" : ""
        } flex items-center cursor-pointer whitespace-pre`}
        onClick={() => {
          if (show === "paymentType") return;
          setTimeout(() => {
            setShow("paymentType");
          });
        }}
      >
        支付方式
        <BottomFillIcon
          size={32}
          fill={show === "paymentType" ? `#3264FF` : `#333`}
          style={{ transform: `rotate(${show === "paymentType" ? 180 : 0}deg)` }}
        />
      </div>
      {show === "paymentType" && (
        <div
          className='text-14 w-130  text-black  gap-20 bg-white absolute rounded-2 z-1 overflow-hidden py-4 box-shadow-inner rounded-4'
          style={{ border: "1px solid #E8E8E8", left: "-35px", top: "32px" }}
        >
          {data?.length > 0 &&
            data.map((item: any, index: number) => (
              <div
                id='paymentTypeItem'
                className={`${
                  action === `${item.value}` ? "bg-[#3264FF] text-white" : ""
                }  cursor-pointer flex items-center h-32 justify-center hover:bg-[#3264FF] hover:text-white`}
                key={index}
                onClick={() => {
                  onClick(item);
                }}
              >
                {item.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default InsuranceList;
